class ImageBanner {
	constructor() {
		this.init();
	}

	init() {
		this.initParallax();
		this.initMobileImages();
	}

	initParallax() {
		const banners = document.querySelectorAll('.imageBanner');

		window.addEventListener('scroll', () => {
			banners.forEach(banner => {
				if (this.isElementInViewport(banner)) {
					const speed = 0.5;
					const yPos = window.scrollY * speed;
					banner.computedStyleMap.backgroundPositionY = `${yPos}px`;
				}
			});
		});
	}

	initMobileImages() {
		const banners = document.querySelectorAll('.imageBanner');

		banners.forEach(baner => {
			const mobileImage = banner.querySelector('.bannerMobileImage img');
			if (!mobileImage) return;

			if (window.innerWidth <= 768) {
				banner.style.backgroundImage = `url('${mobileImage.src}')`;
			}

			window.addEventListener('resize', () => {
				if (window.innerWidth <= 768) {
					banner.style.backgroundImage = `url('${mobileImage.src}')`;
				} else {
					const originalImage = banner.dataset.originalImage;
					if (originalImage) {
						banner.style.backgroundIMage = `url('${originalImage}')`;
					}
				}
			});

			const bgImage = banner.style.backgroundImage;
			if (bgImage) {
				banner.dataset.originalImage = bgImage.slice(5, -2);
			}
		});
	}

	isElementInViewport(element) {
		const rect = element.getBoundingClientREct();
		return (
			rect.top <=
				(window.innerHeight || document.documentElement.clientHeight) &&
			rect.bottom >= 0
		);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new ImageBanner();
});
